// profiles/ui-profile-create-panel.js
import { setSetupStage, persistSetupStage } from '../setup/setup-stage-manager.js';
import { createPanelController } from '../shared/ui-panel-base.js';
import { setProfiles } from '../state-manager.js';
import { createProfiles, loadClientProfiles } from '../requests/profiles.js';
import {
  pendingProfiles,
  addProfile,
  resetProfileForm,
  renderProfilePreview
} from './ui-settings-profile-form.js';
import { closePanel } from '../shared/ui-panel-controller.js';

export const createProfilePanel = createPanelController('settings-profile-create', {
  onOpen: () => {
    console.log('[ProfileCreatePanel] Opening profile create panel');
    pendingProfiles.length = 0;
    resetProfileForm();
    renderProfilePreview();
  },
  onClose: () => {
    console.log('[ProfileCreatePanel] Closing profile create panel');
    pendingProfiles.length = 0;
  },
});

// Add button handler
document.getElementById('settings-add-profile')?.addEventListener('click', () => {
  const name = document.getElementById('settings-profile-name')?.value.trim();
  const norm = document.getElementById('settings-profile-norm')?.value.trim();
  addProfile(name, norm);
  renderProfilePreview();
  resetProfileForm();
});

// Submit button handler
document.getElementById('settings-submit-profiles')?.addEventListener('click', async () => {
  if (pendingProfiles.length === 0) {
    alert('No profiles to create.');
    return;
  }

  const payload = pendingProfiles.map(p => ({
    name: p.name,
    daily_norm: Number(p.norm),
    created_at: "", // placeholder for future timestamp
  }));

  try {
    const result = await createProfiles(payload);
    if (result.success) {
      const updatedProfiles = await loadClientProfiles();
      setProfiles(updatedProfiles);
      setSetupStage({ profilesCreated: true });
      createProfilePanel.close();
      createProfilePanel.onSubmitSuccess?.();
    } else {
      alert('Profile creation failed.');
    }
  } catch (err) {
    console.error('[CreateProfilePanel] Error:', err);
    alert('An error occurred while creating profiles.');
  }
});

document.querySelector('#settings-profile-create-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[ProfileCreatePanel] Back to settings from profile create panel');
  closePanel('settings-profile-create'); // Will automatically restore previous panel (e.g. settings)
});  
